import { Chip } from "@legal-500/legal500-design-system";
import styles from "./Review.module.css";
import type { ReviewStatus } from "../../../api/pendingCompanies.service";

export function ReviewStatusBadge({ status }: { status: ReviewStatus }) {
  const colors = { pending: "warning", approved: "success", rejected: "error" } as const;
  return (
    <Chip className={styles[status]} size="small" variant="filled" color={colors[status]}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Chip>
  );
}
